// 拼音首字母搜索工具（简化版：覆盖项目内常见姓名用字）
// 如需扩展：在 pinyinMap 中追加汉字→拼音首字母映射

const pinyinMap = {
  // 常见姓氏
  张: 'z', 李: 'l', 王: 'w', 赵: 'z', 钱: 'q', 孙: 's', 周: 'z', 吴: 'w',
  郑: 'z', 陈: 'c', 刘: 'l', 黄: 'h', 杨: 'y', 朱: 'z', 林: 'l', 何: 'h',
  罗: 'l', 高: 'g', 马: 'm', 梁: 'l', 宋: 's', 唐: 't', 许: 'x', 韩: 'h',
  冯: 'f', 邓: 'd', 曹: 'c', 彭: 'p', 曾: 'z', 肖: 'x', 田: 't', 董: 'd',
  袁: 'y', 潘: 'p', 于: 'y', 蒋: 'j', 蔡: 'c', 余: 'y', 杜: 'd', 叶: 'y',
  程: 'c', 苏: 's', 魏: 'w', 吕: 'l', 丁: 'd', 任: 'r', 沈: 's', 姚: 'y',
  卢: 'l', 姜: 'j', 崔: 'c', 钟: 'z', 谭: 't', 陆: 'l', 汪: 'w', 范: 'f',
  金: 'j', 石: 's', 廖: 'l', 贾: 'j', 夏: 'x', 韦: 'w', 付: 'f', 方: 'f',
  白: 'b', 邹: 'z', 孟: 'm', 熊: 'x', 秦: 'q', 邱: 'q', 尹: 'y', 薛: 'x',
  闫: 'y', 段: 'd', 雷: 'l', 侯: 'h', 龙: 'l', 史: 's', 黎: 'l', 贺: 'h',
  顾: 'g', 毛: 'm', 郝: 'h', 龚: 'g', 邵: 's', 万: 'w', 钱: 'q', 严: 'y',
  // 常见名字用字
  明: 'm', 娜: 'n', 强: 'q', 伟: 'w', 芳: 'f', 敏: 'm', 静: 'j', 丽: 'l',
  磊: 'l', 军: 'j', 洋: 'y', 勇: 'y', 艳: 'y', 杰: 'j', 娟: 'j', 涛: 't',
  秀: 'x', 华: 'h', 平: 'p', 刚: 'g', 桂: 'g', 英: 'y', 建: 'j', 文: 'w',
  辉: 'h', 玲: 'l', 梅: 'm', 丹: 'd', 宇: 'y', 欣: 'x', 婷: 't', 慧: 'h',
  雪: 'x', 洁: 'j', 晨: 'c', 阳: 'y', 飞: 'f', 龙: 'l', 波: 'b', 鹏: 'p',
  红: 'h', 颖: 'y', 佳: 'j', 晶: 'j', 莹: 'y', 琳: 'l', 瑶: 'y', 怡: 'y',
  萱: 'x', 彤: 't', 薇: 'w', 琪: 'q', 涵: 'h', 梦: 'm', 雨: 'y', 思: 's',
  // 数字（作为汉字姓名的一部分）
  一: 'y', 二: 'e', 三: 's', 四: 's', 五: 'w', 六: 'l', 七: 'q', 八: 'b',
  九: 'j', 十: 's', 百: 'b', 千: 'q', 万: 'w'
}

/**
 * 获取姓名的拼音首字母串
 * @param {string} name 姓名
 * @returns {string} 拼音首字母，如 "张三" → "zs"
 */
export function getPinyinInitials(name) {
  if (!name) return ''
  return name.split('').map(c => pinyinMap[c] || '').join('')
}

/**
 * 根据关键词过滤列表，支持拼音首字母匹配
 * @param {Array} list 数据列表
 * @param {string} keyword 搜索关键词
 * @param {string} nameField 姓名字段名，默认 'real_name'
 * @returns {Array} 过滤后的列表
 */
export function filterByPinyin(list, keyword, nameField = 'real_name') {
  if (!keyword) return list
  const k = keyword.toLowerCase()
  return list.filter(item => {
    const name = item[nameField] || ''
    const initials = getPinyinInitials(name)
    return name.includes(k) || initials.includes(k)
  })
}
